import React from 'react'
import { useSelector } from 'react-redux'

import { BookMode, selectCurrentBook } from 'store/services/Book'
import { selectExercisesByCurrentBookId } from 'store/services/Exercise'

import './ExerciseProgressBar.scss'

const ExerciseProgress: React.FC = () => {
  const { bookProgress, bookMode } = useSelector(selectCurrentBook)
  const exercises = useSelector(selectExercisesByCurrentBookId)

  const currentIndex = bookMode === BookMode.READ ? bookProgress?.index || 0 : bookProgress?.indexListening || 0

  const progressWidthInPercent = `${(currentIndex / exercises.length) * 100}%`

  return (
    <div
      className="exercise-progress-bar"
      role="progressbar"
      aria-label="Exercise progress"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(parseFloat(progressWidthInPercent))}
    >
      <div className="exercise-progress-bar__progress" style={{ width: progressWidthInPercent }} aria-hidden="true" />
    </div>
  )
}

export default ExerciseProgress
